export enum WeightUnitEnum {
	POUND = 'LB',
	KILOGRAM = 'KG'
}
